import { render, staticRenderFns } from "./ThemeBackgroundPane.vue?vue&type=template&id=f59dcd48&scoped=true"
import script from "./ThemeBackgroundPane.vue?vue&type=script&lang=js"
export * from "./ThemeBackgroundPane.vue?vue&type=script&lang=js"
import style0 from "./ThemeBackgroundPane.vue?vue&type=style&index=0&id=f59dcd48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59dcd48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f59dcd48')) {
      api.createRecord('f59dcd48', component.options)
    } else {
      api.reload('f59dcd48', component.options)
    }
    module.hot.accept("./ThemeBackgroundPane.vue?vue&type=template&id=f59dcd48&scoped=true", function () {
      api.rerender('f59dcd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ThemeBackgroundPane.vue"
export default component.exports